<div fxLayout="row" class="dd-phone-number" fxLayoutGap="7px" fxLayoutAlign="center center">
  <mat-icon class="material-icons" aria-label="Phone" rol="img" *ngIf="!isLexus && showPhoneIcon && phoneNumber" >
    <img src="../../../../assets/icons/icon-contact-us.svg" />
  </mat-icon>
  <mat-icon class="material-icons" aria-label="Phone" rol="img" *ngIf="isLexus && showPhoneIcon && phoneNumber" >
    <img src="../../../../assets/icons/icon-contact-us-lexus.svg" />
  </mat-icon>
  <div *ngIf="!isLexus" class="dd-contact-us-text">
    <a href="tel:{{phoneNumber}}" fxShow.gt-xs="false" fxShow="true">{{phoneNumber
      | phoneNumber}}</a>
    <span fxShow.gt-xs="true" fxShow="false" class="dd-red-text">{{phoneNumber | phoneNumber}}</span>
  </div>
  <div *ngIf="isLexus" class="dd-contact-us-text">
    <a href="tel:{{phoneNumber}}" fxShow.gt-xs="false" fxShow="true">{{phoneNumber
      | phoneNumber}}</a>
    <span fxShow.gt-xs="true" fxShow="false" class="dd-lexus-text">{{phoneNumber | phoneNumber}}</span>
  </div>
</div>
<!--[ngClass]="styleClass"-->
